document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const refCode = params.get('RefCode');

    // RefCodeがURLに存在する場合、セッションに保存
    if (refCode) {
         sessionStorage.setItem('RefCode', refCode);
    }

});